import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export const authClient = new UserManager({
  authority: "https://auth.cloud.kdn.biz.ua",
  client_id: "363370724943003653",

  // redirect_uri: window.location.origin + "/auth/callback",
  redirect_uri: "http://localhost:3900/auth/callback",
  // post_logout_redirect_uri: window.location.origin,
  post_logout_redirect_uri: "http://localhost:3900",

  automaticSilentRenew: true,

  response_type: "code",
  scope: "openid profile email offline_access",


  userStore: new WebStorageStateStore({
    store: window.localStorage
  })
  // prompt: "login",

  // automaticSilentRenew: true,
  // silent_redirect_uri: window.location.origin + "/auth/silent-refresh"
});
